import './App.css';

import React, { useEffect, useState } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import Login from './components/Login/Login';
import DefaultLayout from './layout/DefaultLayout';
import PageNotFound from './page/4O4/4O4';
import { getRoutesByRole } from './routes/routes';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState<boolean>(false);
  const token = localStorage.getItem("accessToken");
  const role = localStorage.getItem("role");

  useEffect(() => {
    setIsLoggedIn(!!token);
  }, []);

  // useEffect(() => {
  //   // Request microphone permission with user prompt
  //   const requestMicrophonePermission = async () => {
  //     const shouldRequest = window.confirm(
  //       "This application needs microphone access. Would you like to grant permission?"
  //     );

  //     if (shouldRequest) {
  //       try {
  //         const stream = await navigator.mediaDevices.getUserMedia({
  //           audio: true,
  //         });
  //         // Stop the stream immediately after getting permission
  //         stream.getTracks().forEach((track) => track.stop());
  //         toast.success("Microphone permission granted");
  //       } catch (error) {
  //         toast.error("Microphone permission denied");
  //         console.error("Error accessing microphone:", error);
  //       }
  //     } else {
  //       toast.error("Microphone permission required for full functionality");
  //     }
  //   };

  //   requestMicrophonePermission();
  // }, []);

  useEffect(() => {
    if (process.env.REACT_APP_PROJECT_MODE === "production") {
      const handleContextMenu = (e: MouseEvent) => {
        e.preventDefault();
      };

      const handleKeyDown = (e: KeyboardEvent) => {
        if (e.key === "F12" || (e.ctrlKey && e.shiftKey && e.key === "I")) {
          e.preventDefault();
        }
      };

      document.addEventListener("contextmenu", handleContextMenu);
      document.addEventListener("keydown", handleKeyDown);

      return () => {
        document.removeEventListener("contextmenu", handleContextMenu);
        document.removeEventListener("keydown", handleKeyDown);
      };
    }
  }, []);

  const handleLogin = () => {
    setIsLoggedIn(true);
  };

  const renderRoutes = () => {
    if (!token) {
      return (
        <>
          <Route path="/" element={<Login onLogin={handleLogin} />} />
          <Route path="/login" element={<Login onLogin={handleLogin} />} />
        </>
      );
    }

    const routes = getRoutesByRole(role || "");
    return (
      <>
        {routes.map(({ path, element }) => (
          <Route key={path} path={path} element={element} />
        ))}
        <Route
          path="*"
          element={
            <DefaultLayout>
              <PageNotFound />
            </DefaultLayout>
          }
        />
      </>
    );
  };

  return (
    <div>
      <BrowserRouter>
        <Routes>{renderRoutes()}</Routes>
      </BrowserRouter>
      <ToastContainer position="top-right" autoClose={3000} newestOnTop draggable pauseOnHover />
    </div>
  );
}

export default App;
